import { render, staticRenderFns } from "./investDetails.vue?vue&type=template&id=764917f1&"
import script from "./investDetails.vue?vue&type=script&lang=js&"
export * from "./investDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports